import * as pricingDataTypes from '../constants/pricingPresetDataTypes';
import _ from 'lodash';

const QuotePricing = (_pricingProfiles) => {
  let pricingProfiles = [];
  for(let n = 0; n < _pricingProfiles.length; n++) {
    if(_pricingProfiles[n].PricingPresetData || _pricingProfiles[n].pricingPresetData) {
      var profile = _pricingProfiles[n];
      profile.pricingProfileData = JSON.parse(_pricingProfiles[n].PricingPresetData || _pricingProfiles[n].pricingPresetData);
      pricingProfiles.push(profile);
    }
  }
  var quotePricing = {
    pricingProfiles: pricingProfiles,
    calculatePrice: (pricingProfileId, materialQuantity, stoneSupplierStone = null) => {
      let quantity = parseFloat(materialQuantity);
      var profile = _.first(quotePricing.pricingProfiles.filter((pp) => {
        return (pp.Id || pp.id) === pricingProfileId;
      }));
      if(!profile) {
        throw "Invalid Pricing Profile: Id does not match an existing profile";
      }
      var ppdList = profile.pricingProfileData;
      for(var n = ppdList.length - 1; n >= 0; n--) {
        let ppd = ppdList[n]
          , ppdValue = parseFloat(ppd.value)
          , ppdStart = parseFloat(ppd.start)
          , ppdEnd = parseFloat(ppd.end) || Infinity;
        if(ppd.type === pricingDataTypes.PRICING_PRESET_SLAB_SEG) {
          console.log(ppdValue, stoneSupplierStone);
          if(stoneSupplierStone && stoneSupplierStone.ProfilePriceOverride)
            ppdValue = stoneSupplierStone.Price;
          var slabs = parseInt(Math.ceil(quantity / ppdEnd));
          return slabs * ppdValue;
        } else {
          if ( ppdEnd >= quantity && ppdStart < quantity ) {
            var price = ppdValue;
            switch(ppd.type) {
              case pricingDataTypes.PRICING_PRESET_SQFT_SEG:
                return price * quantity;
              case pricingDataTypes.PRICING_PRESET_PLUS_SQFT_SEG: {
                let prev = ppdList[n - 1]
                  , prevEnd = parseFloat(prev.end)
                  , prevValue = parseFloat(prev.value)
                  , prevPrice = prevEnd * prevValue
                  , remainder = quantity - prevEnd;
                  return prevPrice + (remainder * price);
              }
              case pricingDataTypes.PRICING_PRESET_PKG_SEG:
                return price;
              case pricingDataTypes.PRICING_PRESET_PLUS_PKG_SEG: {
                let prev = ppdList[n - 1]
                  , prevEnd = parseFloat(prev.end)
                  , prevPrice = parseFloat(prev.value)
                  , remainder = quantity - prevEnd;
                  return prevPrice + (remainder * price);
              }
              case pricingDataTypes.PRICING_PRESET_MIN_SEG:
                //return price * ppdEnd; //Minimum 
                return price;
            }
          }
        }
        if(n === 0) { //usually gets caught here if the material value is 0 or NaN
          return quantity * ppdList[0].price;
        }
      }
      //this code should never be reached, but just in case, default to sqft price
      console.error('Code reached that should never be reached in QuotePricing module calculatePrice function', pricingProfiles, pricingProfileId, materialQuantity);
      return quantity * ppdList[0].price;
    },
    hasPricingProfileAssigned: (stoneSupplierStone) => {
      var ppid = stoneSupplierStone.PricingPreset_Id || stoneSupplierStone.pricingPreset_Id;
      var profile = _.first(quotePricing.pricingProfiles.filter((pp) => {
        return ppid === pp.Id || pp.id;
      }));
      return !!profile && !!profile.pricingProfileData;
    }
  };
  return quotePricing;
};

export default QuotePricing;
export { QuotePricing };


// WEBPACK FOOTER //
// ./node_modules/shared_components/businessLogic/QuotePricing.js